export const userInfo = (state) => state.userInfo
export const adminIdentity = (state) =>
  state.adminIdentity.length > 0 ? state.adminIdentity : null
export const adminIdentityInfo = (state) =>
  state.adminIdentity.length > 0
    ? state.adminIdentity[+state.adminIdentityIndex]
    : null
export const adminIdentityIndex = (state) => state.adminIdentityIndex
export const theUserIdentity = (state) => state.theUserIdentity
export const currentRouteInfo = (state) => state.currentRouteInfo
export const routeList = (state) => {
  // 代理商不展示数据中心
  if (+state.adminIdentity[+state.adminIdentityIndex].orgType === 7) {
    return state.routeList.filter((item) => {
      return item.menuName !== '数据中心'
    })
  } else {
    return state.routeList
  }
}
export const leftNavList = (state) => state.leftNavList
export const fileUploadToken = (state) => state.fileUploadToken
export const fileUploadUrl = (state) => state.fileUploadUrl
export const cacheRoute = (state) => state.cacheRoute
export const schoolInfo = (state) => state.schoolList[state.schoolIndex]
export const schoolList = (state) => state.schoolList
export const orgByOpe = (state) => state.orgByOpe
export const schByOpe = (state) => state.schByOpe
export const checkStuListStore = (state) => state.checkStuListStore
export const routeTitle = (state) => state.routeTitle
export const columnsModule = (state) => state.columnsModule
export const leftSwitch = (state) => state.leftSwitch
export const browsingHistoryList = (state) => state.browsingHistoryList
export const portOrg = (state) => state.portOrg
export const authMap = (state) => state.authMap
